module.exports = __webpack_public_path__ + "img/icon-bscegt-usdt.e3796947.png";